// Port of src/app/services/youtube/youtube-user-account.service.ts.

import { environment } from '../../config/environment';
import * as youtubeTokens from './youtube-tokens';
import { exchangeCodeForToken, getUserProfile } from './youtube-base';

export function authenticateUser(): void {
  // Clear previous user data
  youtubeTokens.clearCredentials();

  window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?` +
    `client_id=${encodeURIComponent(environment.youtubeClientId)}` +
    `&redirect_uri=${encodeURIComponent(environment.youtubeRedirectUri)}` +
    `&response_type=code` +
    `&scope=${encodeURIComponent('https://www.googleapis.com/auth/youtube https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email')}` +
    `&access_type=offline`;
}

export function disconnectAccount(): void {
  youtubeTokens.clearCredentials();
}

export function handleAuthenticationCallback(code: string): Promise<any> {
  return exchangeCodeForToken(code);
}

export function saveUserData(accessToken: string, refreshToken: string, email: string): Promise<any> {
  youtubeTokens.setTokens(accessToken, refreshToken, email);
  setIsYoutubeConnected();
  return getUserProfile();
}

export function setIsYoutubeConnected(): void {
  youtubeTokens.setIsYoutubeConnected();
}
